//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import VueRecaptcha from 'vue-recaptcha';
import md5 from "md5";
export default {
  name: 'UserRegister',
  components: { VueRecaptcha },
  data:function(){
    return{
      newUser: {}, password: {pswd1: '', pswd2: ''},
      model: null,
      aplTypeOption: [
        {label: 'Perorangan',value: '1',},
        {label: 'Kelompok Orang',value: '2',},
        {label: 'Badan Hukum',value: '3',},
      ],
      slcAplType : {label: 'Perorangan',value: '1',},
      idTypeOption:[
        {label: 'KTP',value: '1',},
        {label: 'Surat Kuasa',value: '2',},
        {label: 'Surat Permohonan',value: '3',},
      ],
      slcIdType: {label: 'KTP',value: '1',},
      accept: false,
      file_upload: '',
      theFile: {},
      selectFile: ''
    }
  },
  mounted(){

  },
  methods:{
    chgFile(){
      this.selectFile = this.$refs.scan.files[0].name
    },
    onSubmit () {
      this.$refs.apltype.validate();this.$refs.idtype.validate();this.$refs.noid.validate()
      this.$refs.npwp.validate();
      this.$refs.name.validate();this.$refs.addr.validate()
      this.$refs.phone.validate();this.$refs.empl.validate();this.$refs.userid.validate()
      this.$refs.email.validate();this.$refs.fax.validate();this.$refs.pswd.validate()
      this.$refs.conpswd.validate()

      if (this.$refs.apltype.hasError || this.$refs.idtype.hasError || this.$refs.noid.hasError || 
          this.$refs.npwp.hasError || 
          this.$refs.name.hasError || this.$refs.addr.hasError || 
          this.$refs.phone.hasError || this.$refs.empl.hasError || this.$refs.userid.hasError || 
          this.$refs.email.hasError || this.$refs.fax.hasError || this.$refs.pswd.hasError || 
          this.$refs.conpswd.hasError) 
      {
        this.formHasError = true
      }
      else if(this.password.pswd1 != this.password.pswd2){
        this.$q.notify({
          color: 'negative', message: 'Konfirmasi Password salah atau tidak sesuai!'
        })
      }
      else if (this.accept !== true) {
        this.$q.notify({
          color: 'negative', message: 'Anda Harus Menyetujui Pernyataan Terlebih Dahulu!'
        })
      }
      else {
        this.newUser.password_text = this.password.pswd1
        this.newUser.password = md5(this.password.pswd1)
        this.uploadfile()

        this.$q.notify({
          icon: 'done', color: 'positive', message: 'Berhasil registrasi'
        })
      }
    },
    uploadfile(){
      if(!this.$refs.scan.files[0]){
        this.$q.notify({
          color: 'negative', message: 'Anda belum pilih file bukti identitas!'
        })
      }
      else {
        this.theFile = this.$refs.scan.files[0];
        var formData = new FormData();
        formData.append("file", this.theFile);
        formData.append("folder", 'userfile/');

        this.$http.post('/upload.php', formData, {headers: { "Content-Type": "multipart/form-data" }})
        .then(async result => {

          var dt = new Date()
          var year = dt.getFullYear() 
          var month = dt.getMonth()+1
          var day = dt.getDate()
          this.newUser.identityScanCard = await year.toString() + (month<10? '0'+month:month.toString()) + (day<10? '0'+day:day.toString()) + '_' +this.theFile.name

          this.$http.post('/new_user/', this.newUser, {})
            .then (result => {
              this.$router.push('/user/login')
            })
        })
      }
    },
  },
  computed:{
    showbutton(){
      return false
    }
  }
}
